export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

// Default max distance, will be overridden by service configuration
export const DEFAULT_MAX_DISTANCE_KM = 500;

export const countryCodes = [
  {
    code: '+1',
    name: 'United States',
    country: 'US',
    flag: '🇺🇸'
  },
  {
    code: '+44',
    name: 'United Kingdom',
    country: 'GB',
    flag: '🇬🇧'
  },
  {
    code: '+91',
    name: 'India',
    country: 'IN',
    flag: '🇮🇳'
  },
  {
    code: '+86',
    name: 'China',
    country: 'CN',
    flag: '🇨🇳'
  },
  {
    code: '+52',
    name: 'Mexico',
    country: 'MX',
    flag: '🇲🇽'
  },
  {
    code: '+49',
    name: 'Germany',
    country: 'DE',
    flag: '🇩🇪'
  },
  {
    code: '+33',
    name: 'France',
    country: 'FR',
    flag: '🇫🇷'
  },
  {
    code: '+81',
    name: 'Japan',
    country: 'JP',
    flag: '🇯🇵'
  },
  {
    code: '+55',
    name: 'Brazil',
    country: 'BR',
    flag: '🇧🇷'
  },
  {
    code: '+61',
    name: 'Australia',
    country: 'AU',
    flag: '🇦🇺'
  },
  {
    code: '+34',
    name: 'Spain',
    country: 'ES',
    flag: '🇪🇸'
  },
  {
    code: '+39',
    name: 'Italy',
    country: 'IT',
    flag: '🇮🇹'
  },
  {
    code: '+7',
    name: 'Russia',
    country: 'RU',
    flag: '🇷🇺'
  },
  {
    code: '+82',
    name: 'South Korea',
    country: 'KR',
    flag: '🇰🇷'
  },
  {
    code: '+31',
    name: 'Netherlands',
    country: 'NL',
    flag: '🇳🇱'
  },
  {
    code: '+46',
    name: 'Sweden',
    country: 'SE',
    flag: '🇸🇪'
  },
  {
    code: '+47',
    name: 'Norway',
    country: 'NO',
    flag: '🇳🇴'
  },
  {
    code: '+45',
    name: 'Denmark',
    country: 'DK',
    flag: '🇩🇰'
  },
  {
    code: '+358',
    name: 'Finland',
    country: 'FI',
    flag: '🇫🇮'
  },
  {
    code: '+48',
    name: 'Poland',
    country: 'PL',
    flag: '🇵🇱'
  },
  {
    code: '+43',
    name: 'Austria',
    country: 'AT',
    flag: '🇦🇹'
  },
  {
    code: '+32',
    name: 'Belgium',
    country: 'BE',
    flag: '🇧🇪'
  },
  {
    code: '+41',
    name: 'Switzerland',
    country: 'CH',
    flag: '🇨🇭'
  },
  {
    code: '+351',
    name: 'Portugal',
    country: 'PT',
    flag: '🇵🇹'
  },
  {
    code: '+30',
    name: 'Greece',
    country: 'GR',
    flag: '🇬🇷'
  },
  {
    code: '+353',
    name: 'Ireland',
    country: 'IE',
    flag: '🇮🇪'
  },
  {
    code: '+64',
    name: 'New Zealand',
    country: 'NZ',
    flag: '🇳🇿'
  },
  {
    code: '+852',
    name: 'Hong Kong',
    country: 'HK',
    flag: '🇭🇰'
  },
  {
    code: '+65',
    name: 'Singapore',
    country: 'SG',
    flag: '🇸🇬'
  },
  {
    code: '+971',
    name: 'United Arab Emirates',
    country: 'AE',
    flag: '🇦🇪'
  },
  {
    code: '+972',
    name: 'Israel',
    country: 'IL',
    flag: '🇮🇱'
  },
  {
    code: '+966',
    name: 'Saudi Arabia',
    country: 'SA',
    flag: '🇸🇦'
  },
  {
    code: '+20',
    name: 'Egypt',
    country: 'EG',
    flag: '🇪🇬'
  },
  {
    code: '+27',
    name: 'South Africa',
    country: 'ZA',
    flag: '🇿🇦'
  },
  {
    code: '+234',
    name: 'Nigeria',
    country: 'NG',
    flag: '🇳🇬'
  },
  {
    code: '+254',
    name: 'Kenya',
    country: 'KE',
    flag: '🇰🇪'
  },
  {
    code: '+62',
    name: 'Indonesia',
    country: 'ID',
    flag: '🇮🇩'
  },
  {
    code: '+84',
    name: 'Vietnam',
    country: 'VN',
    flag: '🇻🇳'
  },
  {
    code: '+60',
    name: 'Malaysia',
    country: 'MY',
    flag: '🇲🇾'
  },
  {
    code: '+66',
    name: 'Thailand',
    country: 'TH',
    flag: '🇹🇭'
  },
  {
    code: '+63',
    name: 'Philippines',
    country: 'PH',
    flag: '🇵🇭'
  },
  {
    code: '+679',
    name: 'Fiji',
    country: 'FJ',
    flag: '🇫🇯'
  }
];

export const rideOptions = {
  economy: { 
    name: 'Economy', 
    comfort: 'Standard comfort, suitable for short trips',
    features: ['Basic amenities', 'Air conditioning']
  },
  comfort: { 
    name: 'Comfort',
    comfort: 'Enhanced comfort with extra legroom',
    features: ['Premium seats', 'Climate control', 'USB charging']
  },
  premium: { 
    name: 'Premium',
    comfort: 'Luxury comfort with premium features',
    features: ['Leather seats', 'Advanced climate control', 'Premium audio', 'Extra legroom']
  }
};

export const paymentOptions = [
  { value: 'cash', label: 'Cash' },
  { value: 'card', label: 'Credit/Debit Card' },
  { value: 'mobile', label: 'Mobile Payment' },
  { value: 'corporate', label: 'Corporate Account' }
];
